import { render, staticRenderFns } from "./SamTextListItem.vue?vue&type=template&id=32934d7a&scoped=true&shadow"
import script from "./SamTextListItem.vue?vue&type=script&lang=js&shadow"
export * from "./SamTextListItem.vue?vue&type=script&lang=js&shadow"
function injectStyles (context) {
  
  var style0 = require("./SamTextListItem.vue?vue&type=style&index=0&id=32934d7a&prod&scoped=true&lang=scss&shadow")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "32934d7a",
  null
  ,true
)

export default component.exports